/**
 * @copyright © Paramount Streaming
 * @description Content type identifiers for Pluto TV API requests.
 * Matches the values supplied via paramsVO.STITCHER.type.
 */
export enum PTVContentType {
	CHANNEL = 'channel',
	MOVIE = 'movie',
	EPISODE = 'episode'
}